import { ChecklistFieldType } from '@cobliteam/api-lib/src/dashboard/checklist';
import { z } from 'zod';

const refineSchema = (value: any, ctx: z.RefinementCtx, hasGroupsRestriction: boolean) => {
  const { vehicleIds } = value;

  if (hasGroupsRestriction && (!vehicleIds || vehicleIds.length === 0)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Selecione pelo menos um grupo ou veículo.',
      path: ['vehicleIds'],
    });
  }
};

const createFormSchema = (hasGroupsRestriction: boolean) =>
  z
    .object({
      name: z.string().min(1, 'Campo obrigatório'),
      active: z.boolean(),
      vehicleIds: z.array(z.string()),
      vehicleGroupIds: z.array(z.string()).optional(),
      items: z
        .array(
          z.object({
            title: z.string().min(1, 'Campo obrigatório'),
            type: z.nativeEnum(ChecklistFieldType),
            required: z.boolean(),
            shouldRequestPhotos: z.boolean().optional(),
            content: z.object({
              value: z.string().nullable(),
              checked: z.boolean().nullable(),
              label: z.string().nullable(),
              options: z.array(z.object({ label: z.string().min(1, 'Campo obrigatório') })).nullable(),
            }),
          })
        )
        .min(1, '*Adicione pelo menos um item'),
    })
    .superRefine((data, ctx) => refineSchema(data, ctx, hasGroupsRestriction));

type FormValues = z.infer<ReturnType<typeof createFormSchema>>;

export { createFormSchema, type FormValues };
